import _ from "lodash"

export default function (newList) {
  // ensure there's more than one item
  if (newList.length === 1) return []

  return _.reduce(
    newList,
    (acc, item, index) => {
      let assignNewPosition = false
      let newPosition

      // at first
      if (index === 0) {
        let nextItemPosition = newList[index + 1].attributes.position
        if (item.attributes.position !== null && item.attributes.position < nextItemPosition) {
          assignNewPosition = false
        } else {
          assignNewPosition = true
          newPosition = nextItemPosition - 1000
        }

        // at end
      } else if (index === newList.length - 1) {
        let prevItemPosition = _.last(acc)[1]
        if (item.attributes.position === null || item.attributes.position <= prevItemPosition) {
          assignNewPosition = true
          newPosition = prevItemPosition + 1000
        } else {
          assignNewPosition = false
        }

        // in the middle
      } else {
        let nextItemPosition = newList[index + 1].attributes.position
        let prevItemPosition = _.last(acc)[1]
        let itemPosition = item.attributes.position
        if (nextItemPosition === null) {
          assignNewPosition = false
        } else if (
          itemPosition !== null &&
          itemPosition > prevItemPosition &&
          itemPosition < nextItemPosition
        ) {
          assignNewPosition = false
        } else {
          assignNewPosition = true
          // We assign 1 to prevent cards from having the same number
          newPosition = prevItemPosition + Math.floor((nextItemPosition - prevItemPosition) / 2) + 1
          // newPosition = prevItemPosition     + 500
        }
      }

      if (assignNewPosition) {
        acc.push([item.id, newPosition, item.attributes.position])
      } else {
        acc.push([item.id, item.attributes.position])
      }
      return acc
    },
    []
  )
}
